var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckRoundedFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.0525%",
    cy: "49.9463889%",
    fx: "50.0525%",
    fy: "49.9463889%",
    r: "49.9361111%",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444444",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-rounded-filled",
    fill: "url(#radialGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8575342,0.320547945 C5.76986301,0.320547945 0.0356164384,6.05479452 0.0356164384,13.1424658 C0.0356164384,20.230137 5.76986301,25.9643836 12.8575342,25.9643836 C19.9452055,25.9643836 25.6794521,20.230137 25.6794521,13.1424658 C25.6794521,6.05479452 19.9452055,0.320547945 12.8575342,0.320547945 Z M20.5150685,8.22739726 L12.0739726,18.9123288 C11.9671233,19.0547945 11.7890411,19.1616438 11.5753425,19.1972603 C11.539726,19.1972603 11.539726,19.1972603 11.5041096,19.1972603 C11.3260274,19.1972603 11.1835616,19.1260274 11.0410959,19.0191781 L6.05479452,14.7808219 C5.76986301,14.5315068 5.73424658,14.0684932 5.98356164,13.7835616 C6.23287671,13.4986301 6.69589041,13.4630137 6.98082192,13.7123288 L11.3972603,17.4520548 L19.3753425,7.3369863 C19.6246575,7.01643836 20.0520548,6.98082192 20.3726027,7.23013699 C20.6931507,7.47945205 20.7287671,7.90684932 20.5150685,8.22739726 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRoundedFilled);
export default __webpack_public_path__ + "static/media/check-rounded-filled.6db7217937ae5964d03418887d31d3fd.svg";
export { ForwardRef as ReactComponent };